module.exports = __webpack_public_path__ + "static/media/3.f0531e61.jpg";